import { TemplateConfig } from '../types';

export const careerPlanningConfig: TemplateConfig = {
  id: 'career-planning',
  name: '职业规划探索',
  description: '分析适合的职业和提供职业规划建议',
  cardCount: 5,
  
  fieldDefaults: {
    title: '职业规划探索',
    customerQuestion: '分析适合我的职业。分析职业类型、自身优势、目前的状况、自身的短板以及职业建议。从多个角度帮助我更加清晰的进行职业规划探索。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 3 行第 1 张牌'
    ],
    cardInfos: [
      '职业类型',
      '自身优势',
      '目前状况',
      '自身短板',
      '职业建议'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '💼'
  }
};